"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewUserService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class NewUserService {
    /**
     * @param requestBody
     * @returns any Ok
     * @returns CreateUserResult Success
     * @throws ApiError
     */
    static createUser(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v1/new-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                422: `Unprocessable Entity`,
            },
        });
    }
}
exports.NewUserService = NewUserService;
